import React from 'react';

import {
  IconChevronRight,
  IconInfoCircle,
  IconMail,
  IconBug,
} from '@tabler/icons';

import appConfig from '../../mocks/appConfig';

import BackHeader from '../../components/BackHeader';
import { Container, Content, SimpleButton } from './styles';

const Help: React.FC = () => {
  return (
    <Container>
      <BackHeader title="Ajuda" />

      <Content>
        <SimpleButton href="https://ebov.vercel.app/">
          <div>
            <IconInfoCircle
              size={25}
              color="#333"
              style={{ marginRight: 20 }}
            />
            Institucional
          </div>

          <IconChevronRight size={25} color="#333" />
        </SimpleButton>

        <SimpleButton href={`mailto:${appConfig.contactEmail}`}>
          <div>
            <IconMail size={25} color="#333" style={{ marginRight: 20 }} />
            Fale conosco
          </div>

          <IconChevronRight size={25} color="#333" />
        </SimpleButton>
        <SimpleButton href={`mailto:${appConfig.contactEmail}`}>
          <div>
            <IconBug size={25} color="#333" style={{ marginRight: 20 }} />
            Relatar problema
          </div>

          <IconChevronRight size={25} color="#333" />
        </SimpleButton>

        <br />
        <br />

        <span>Versão {appConfig.version}</span>
      </Content>
    </Container>
  );
};

export default Help;
